export default __webpack_public_path__ + "static/media/no-data-pana.f8273fac.svg";